import { OrgPricingResponse } from '@goldcast/api/backend';
import logger from '@goldcast/logger';

import { getEnv } from '@/utils/env';

export function initDriftBot(orgPricingConfig: OrgPricingResponse, userData: any) {
  const driftEnabled = getEnv('VUE_APP_DRIFT_ENABLED') === 'true';
  const driftBotKey = getEnv('VUE_APP_DRIFT_KEY');

  if (!driftEnabled || !driftBotKey) {
    logger.warn('[driftBotService] Drift bot is disabled in this environment');
    return;
  }

  if (!window.drift) {
    logger.error('[driftBotService] Drift bot is not loaded');
    return;
  }

  window.drift.identify(userData.id, {
    name: userData.first_name.concat(' ', userData.last_name).trim() || undefined,
    email: userData.email,
    gc_pricing_tier_name: orgPricingConfig.tier
  });

  window.drift.load(driftBotKey);
}

export function resetDriftBot() {
  if (window.drift && typeof window.drift.unload === 'function') {
    window.drift.unload();
  }

  if (window.drift && typeof window.drift.reset === 'function') {
    window.drift.reset();
  }
}
